// Best-effort initial country for the phone widget on Step02 (contact details),
// which is captured BEFORE the explicit Country step (Step04). Without this a US
// seller silently gets a +44 (GB) dial prefix, producing an unreachable phone number
// (the operator can't SMS them). Heuristic only — the seller can still change the flag
// and their Step04 answer is authoritative for everything downstream. Defaults to 'gb'
// (the historical UK-first behavior) whenever the signal is ambiguous, so UK sellers
// are never regressed.

// Main US IANA timezones. America/* also covers Canada + Latin America, so we match an
// explicit US set rather than the "America/" prefix to avoid mislabeling CA/LatAm users.
const US_TIMEZONES = new Set([
  'America/New_York', 'America/Detroit', 'America/Kentucky/Louisville',
  'America/Kentucky/Monticello', 'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indiana/Marengo',
  'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Knox',
  'America/Indiana/Vevay', 'America/Chicago', 'America/Menominee',
  'America/North_Dakota/Center', 'America/North_Dakota/New_Salem',
  'America/North_Dakota/Beulah', 'America/Denver', 'America/Boise', 'America/Phoenix',
  'America/Los_Angeles', 'America/Anchorage', 'America/Juneau', 'America/Sitka',
  'America/Metlakatla', 'America/Yakutat', 'America/Nome', 'America/Adak',
  'Pacific/Honolulu',
]);

// Returns 'us' or 'gb'. Safe on any platform (guards navigator/Intl access).
export function guessSellerCountry() {
  try {
    const lang = (typeof navigator !== 'undefined' && navigator.language
      ? navigator.language : '').toLowerCase();
    if (lang.startsWith('en-us')) return 'us';
    const tz = (typeof Intl !== 'undefined' && Intl.DateTimeFormat)
      ? (Intl.DateTimeFormat().resolvedOptions().timeZone || '') : '';
    if (US_TIMEZONES.has(tz)) return 'us';
  } catch (_) {
    /* ignore — fall through to the safe default */
  }
  return 'gb';
}
